var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registerPage"},[_c('SimplePage',{scopedSlots:_vm._u([{key:"widgetFooterLeftPart",fn:function(){return [_c('LoginAsGuest')]},proxy:true}])},[(_vm.goToRegister)?_c('RegisterForm'):_c('RegisterNotInvited')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }